import { CampaignPost, CampaignPostsSummary } from '@anytag/graphql';
import { PostDiscoveryMetricsStats } from './types';
import { CampaignPostsDiscoveryRowData } from './types';

const formatCampaignPostStats = (stats?: Partial<PostDiscoveryMetricsStats>): PostDiscoveryMetricsStats => ({
  cost: stats?.cost ?? null,
  views: stats?.views ?? null,
  likes: stats?.likes ?? null,
  shares: stats?.shares ?? null,
  comments: stats?.comments ?? null,
  revenue: stats?.revenue ?? null,
  engagement: stats?.engagement ?? null,
  engagementViewsRate: stats?.engagementViewsRate ?? null,
  engagementFollowersRate: stats?.engagementFollowersRate ?? null,
  reach: stats?.reach ?? null,
  reachRate: stats?.reachRate ?? null,
  followers: stats?.followers ?? null,
  saved: stats?.saved ?? null,
  impressions: stats?.impressions ?? null,
  impressionsRate: stats?.impressionsRate ?? null,
  clicks: stats?.clicks ?? null,
  actions: stats?.actions ?? null,
  sales: stats?.sales ?? null,
  salesCost: stats?.salesCost ?? null,
  conversions: stats?.conversions ?? null,
  orders: stats?.orders ?? null,
  salesReferral: stats?.salesReferral ?? null,
  impressionsFromHome: stats?.impressionsFromHome ?? null,
  impressionsFromProfile: stats?.impressionsFromProfile ?? null,
  impressionsFromOther: stats?.impressionsFromOther ?? null,
  navigation: stats?.navigation ?? null,
  forward: stats?.forward ?? null,
  exited: stats?.exited ?? null,
  nextStory: stats?.nextStory ?? null,
  back: stats?.back ?? null,
  profileActivity: stats?.profileActivity ?? null,
  impressionsClickThroughRate: stats?.impressionsClickThroughRate ?? null,
  audienceRetention: stats?.audienceRetention ?? null,
  impressionsFromDiscovery: stats?.impressionsFromDiscovery ?? null,
  impressionsFromHashtag: stats?.impressionsFromHashtag ?? null,
  averageViewDurationSeconds: stats?.averageViewDurationSeconds ?? null,
  averageViewDurationPercentage: stats?.averageViewDurationPercentage ?? null,
  nonFollowerReach: stats?.nonFollowerReach ?? null,
  nonFollowerReachRate: stats?.nonFollowerReachRate ?? null,
  dislikes: stats?.dislikes ?? null,
  interaction: stats?.interaction ?? null,
  linkClicks: stats?.linkClicks ?? null,
  stickerTaps: stats?.stickerTaps ?? null,
  malePercentage: stats?.malePercentage ?? null,
  femalePercentage: stats?.femalePercentage ?? null,
  age18to24Percentage: stats?.age18to24Percentage ?? null,
  age25to34Percentage: stats?.age25to34Percentage ?? null,
  age35upPercentage: stats?.age35upPercentage ?? null,
  totalPlayTime: stats?.totalPlayTime ?? null,
  averageViewTime: stats?.averageViewTime ?? null,
  videoCompletionRate: stats?.videoCompletionRate ?? null
});

export const formatCampaignPostsDiscoveryData = (data: readonly CampaignPost[], summary?: CampaignPostsSummary) =>
  [
    { className: 'total-row', stats: formatCampaignPostStats(summary?.sum) }, // Total row
    { className: 'average-row', stats: formatCampaignPostStats(summary?.average) }, // Average row
    ...data.map<CampaignPostsDiscoveryRowData>((post) => ({
      stats: formatCampaignPostStats(post),
      influencerInfo: {
        id: post.id,
        avatar: post.avatar,
        content: post.content,
        thumbnail: post.thumbnail,
        influencerId: post.influencerId,
        campaignName: post.campaignName,
        influencerName: post.influencerName,
        socialPostType: post.socialPostType,
        campaignIdentifier: post.campaignIdentifier
      }
    }))
  ] satisfies CampaignPostsDiscoveryRowData[];
